import React from "react";
import { Picture } from "../lib/photos";
import { Breadcrumbs } from "./Breadcrumbs";

/**
 * PageHero — unified hero for internal pages.
 * Left-aligned eyebrow → H1 → intro. Optional right-side hero image.
 * Photo may be null; a solid forest fallback is used.
 */
export function PageHero({
  eyebrow,
  title,
  intro,
  photo,
  breadcrumbs = [],
  align = "left",
  compact = false,
  testId,
}) {
  return (
    <section
      className={`relative pt-28 md:pt-36 ${compact ? "pb-14 md:pb-20" : "pb-20 md:pb-28"} bg-forest-900 text-cream overflow-hidden`}
      data-testid={testId || "page-hero"}
    >
      {photo && (
        <div className="absolute inset-0">
          <Picture
            photo={photo}
            className="absolute inset-0 w-full h-full"
            imgClassName="w-full h-full object-cover opacity-40"
            sizes="100vw"
            loading="eager"
            fetchPriority="high"
          />
          <div className="absolute inset-0 bg-gradient-to-br from-forest-900/85 via-forest-900/70 to-forest-900/60" />
        </div>
      )}
      <div className="container-app relative">
        {breadcrumbs.length > 0 && (
          <div className="mb-8 md:mb-10">
            <Breadcrumbs items={breadcrumbs} className="text-cream/70" />
          </div>
        )}
        <div className={align === "center" ? "text-center max-w-3xl mx-auto" : "max-w-3xl"}>
          {eyebrow && <p className="eyebrow text-brass-300 mb-4">{eyebrow}</p>}
          <h1 className="font-display font-light text-4xl sm:text-5xl md:text-6xl lg:text-7xl leading-[1.02] tracking-tight text-cream">
            {title}
          </h1>
          {intro && (
            <p className="mt-6 text-lg md:text-xl text-cream/85 leading-relaxed font-light max-w-2xl">
              {intro}
            </p>
          )}
        </div>
      </div>
    </section>
  );
}
